import {
    apiRequest,
    riwayatPendidikanUpdate,
    riwayatPendidikanDetail,
    masterEducation,
    masterRumpun
} from "../../../../../services/adapters/kepegawaian/riwayatPendidikanService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", riwayatPendidikanUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatPendidikanDetail, {
            params: query
        }, true)
    }

    fetchEducation= async (query) => {
        return await apiRequest("get", masterEducation, {
            params: query
        }, true)
    }
    fetchRumpun= async (query) => {
        return await apiRequest("get", masterRumpun, {
            params: query
        }, true)
    }
}

export default UpdateRepository